import * as React from "react";
import { LeagueIcon } from "../..";
import { Icon } from "sb-resp-ui";
export const renderLiveStreamIcon = (hasLiveStreaming, liveStreamTooltip) => {
    return (hasLiveStreaming ?
        React.createElement(LeagueIcon, { className: "rj-league-list__live-stream-icon", tooltip: liveStreamTooltip },
            React.createElement(Icon, { i: "i-24-16 i-o-ev-streaming" }))
        : React.createElement(React.Fragment, null));
};
//# sourceMappingURL=renderLiveStreamIcon.js.map